"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainnetConsensusConfig = void 0;
const MainnetConsensusConfig = {
    consensusAppId: 1134695678,
    xAlgoId: 1134696561,
    stakeAndDepositAppId: 2633147490,
};
exports.MainnetConsensusConfig = MainnetConsensusConfig;
//# sourceMappingURL=mainnet-constants.js.map